<template>
  <div
    class="puls-multi-selector attribute-segment-selector"
    :class="`${classes} puls-multi-selector-${variant}`"
  >
    <label v-if="label" class="form-label ms-1">
      {{ label }}
    </label>
    <Multiselect
      :id="`multiselect-${id || label}`"
      ref="multiselect"
      v-model="selectedOptionInternal"
      track-by="name"
      label="title"
      :options="options"
      :searchable="isSearchable"
      :allow-empty="false"
      :show-no-results="false"
      :close-on-select="true"
      :disabled="disabled"
      :placeholder="placeholder"
      selectLabel=""
      deselectLabel=""
      selectedLabel=""
    >
      <template #caret>
        <div
          class="puls-multi-selector__select"
          @mousedown.prevent.stop="handleCaretClick"
        >
          <i class="bi bi-chevron-down"></i>
        </div>
      </template>
      <template #option="props">
        <div
          :style="{
            marginLeft: props.option.level
              ? props.option.level * 10 + 'px'
              : '0px'
          }"
        >
          {{ props.option.title }}
        </div>
      </template>
      <template v-if="$slots.button" #afterList>
        <slot name="button"></slot>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'PulsMultiSelect',
  components: {
    Multiselect
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    onSelectOption: {
      type: Function,
      default: () => {}
    },
    selectedOption: {
      type: Object,
      default: () => {}
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'medium'
    },
    classes: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedOptionInternal: {
        name: this.selectedOption.name,
        title:
          this.selectedOption.title ||
          this.$tr(this.selectedOption.messages, 'title')
      }
    }
  },
  watch: {
    selectedOptionInternal(newValue, oldValue) {
      if (newValue.name !== oldValue.name) {
        this.onSelectOption(this.selectedOptionInternal)
      }
    },
    // if a new selectedOption is selected programmatically, update our internal value
    selectedOption(newValue) {
      this.selectedOptionInternal = newValue
    }
  },
  methods: {
    closeDropdown() {
      this.$refs.multiselect.deactivate()
    },
    handleCaretClick() {
      this.$refs.multiselect.isOpen
        ? this.$refs.multiselect.deactivate()
        : this.$refs.multiselect.activate()
    }
  }
}
</script>
